// extracted by mini-css-extract-plugin
module.exports = {"naver":"NewsNav_naver__1189R","wbg":"NewsNav_wbg__sfbFc"};